import script from "./company.vue?vue&type=script&setup=true&lang=ts"
export * from "./company.vue?vue&type=script&setup=true&lang=ts"

import "./company.vue?vue&type=style&index=0&id=7d8a69ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d8a69ca"]])

export default __exports__